import { render, staticRenderFns } from "./PrecoPrazoModal.vue?vue&type=template&id=fdc5172e&scoped=true"
import script from "./PrecoPrazoModal.vue?vue&type=script&lang=js"
export * from "./PrecoPrazoModal.vue?vue&type=script&lang=js"
import style0 from "./PrecoPrazoModal.vue?vue&type=style&index=0&id=fdc5172e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdc5172e",
  null
  
)

export default component.exports